(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9506],{

/***/ 3198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 7404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ OpenJobsHighlight; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
// EXTERNAL MODULE: ../wif-ui-lib/dist/SectionHeader.js
var SectionHeader = __webpack_require__(933);
// EXTERNAL MODULE: ./src/constants/durations.ts
var durations = __webpack_require__(4780);
// EXTERNAL MODULE: ./src/hooks/useQuery.ts + 1 modules
var useQuery = __webpack_require__(808);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Logo-8772aba7.mjs
var Logo_8772aba7 = __webpack_require__(1658);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-460da2fc.mjs
var Link_460da2fc = __webpack_require__(1607);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-eec2778c.mjs
var Button_eec2778c = __webpack_require__(9358);
// EXTERNAL MODULE: ../wif-ui-lib/dist/JobList.js
var JobList = __webpack_require__(8132);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ./src/magnolia/components/OpenJobsHighlight/OpenJobsHighlight.module.scss
var OpenJobsHighlight_module = __webpack_require__(7241);
var OpenJobsHighlight_module_default = /*#__PURE__*/__webpack_require__.n(OpenJobsHighlight_module);
;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/helpers.ts


var openJobsHighlightId = "open-jobs-highlight";
function getStyleClassName() {
    for(var _len = arguments.length, suffixes = new Array(_len), _key = 0; _key < _len; _key++){
        suffixes[_key] = arguments[_key];
    }
    return (OpenJobsHighlight_module_default())[[
        openJobsHighlightId
    ].concat((0,_to_consumable_array/* default */.Z)(suffixes)).join("__")];
}
function generateOpenJobsPageLink(category) {
    var BASE_URL = "/open-jobs/";
    var searchParams = new URLSearchParams({
        category: category.id
    });
    return BASE_URL + "?" + searchParams.toString();
}

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/useJobsQuery.ts




var JOBS_COUNT_MOBILE = 3;
var JOBS_COUNT_TABLET_DESKTOP = 6;
function useJobsQuery(categoryId) {
    var searchParams = new URLSearchParams({
        offset: "0",
        limit: JOBS_COUNT_TABLET_DESKTOP.toString()
    });
    if (categoryId) searchParams.set("category", categoryId);
    var ref = (0,useQuery/* default */.Z)("/api/jobs/?" + searchParams.toString(), {
        disabled: !categoryId,
        cacheDurationInMs: durations/* ONE_MIN_IN_MS */.sW * 10
    }), result = ref.data, isLoading = ref.isLoading;
    var jobCardsCount = useJobCardsCount();
    if (isLoading || !(result === null || result === void 0 ? void 0 : result.jobs)) return Array(jobCardsCount).fill({
        isDataLoading: true
    });
    return ((result === null || result === void 0 ? void 0 : result.jobs) || []).slice(0, jobCardsCount).map(mapJobToJobCardProps);
}
function useJobCardsCount() {
    var viewport = (0,ViewportContext/* default */.Z)().viewport;
    return (0,react.useMemo)(function() {
        return viewport === "xs" || viewport === "sm" ? JOBS_COUNT_MOBILE : JOBS_COUNT_TABLET_DESKTOP;
    }, [
        viewport
    ]);
}
function mapJobToJobCardProps(job) {
    return {
        title: job.title,
        employerName: job.employer.name,
        location: job.employer.city,
        link: job.externalUrl,
        image: job.employer.imageUrl,
        expireDate: job.expireDate,
        isDataLoading: false
    };
}

// EXTERNAL MODULE: ../wif-ui-lib/dist/main.js
var main = __webpack_require__(128);
;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/useCurrentCategory.ts



function useCurrentCategory() {
    var categories = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], isHovering = arguments.length > 1 ? arguments[1] : void 0;
    var MAX_INDEX = categories.length;
    var ref = (0,react.useTransition)(), startTransition = ref[1];
    var ref1 = (0,react.useState)(0), index = ref1[0], setIndex = ref1[1];
    var isWindowVisible = useIsWindowVisible();
    var isIntervalDisabled = categories.length === 0 || !isWindowVisible || !!isHovering;
    (0,main/* useInterval */.Yz)(function() {
        return startTransition(function() {
            setIndex(function(i) {
                return (i + 1) % MAX_INDEX;
            });
        });
    }, 8 * durations/* ONE_SEC_IN_MS */.mW, {
        disabled: isIntervalDisabled
    });
    return (0,react.useMemo)(function() {
        return categories[index];
    }, [
        categories,
        index
    ]);
}
function useIsWindowVisible() {
    return (0,react.useSyncExternalStore)(subscribeToVisibilityChange, getWindowVisibilitySnapshot, function() {
        return false;
    });
}
function subscribeToVisibilityChange(listener) {
    window.document.addEventListener("visibilitychange", listener);
    return function() {
        return window.document.removeEventListener("visibilitychange", listener);
    };
}
function getWindowVisibilitySnapshot() {
    return window.document.visibilityState === "visible";
}

;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/LatestOpenings.tsx







function LatestOpenings(param) {
    var title = param.title, _categories = param.categories, categories = _categories === void 0 ? [] : _categories, seeMoreButtonText = param.seeMoreButtonText;
    var ref = (0,Logo_8772aba7.u)(), ref1 = ref.ref, isHovering = ref.isHovering;
    var currentCategory = useCurrentCategory(categories, isHovering);
    var jobs = useJobsQuery(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id);
    if (!currentCategory) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(useClickOutside_55c64a80.B.Content, {
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: getStyleClassName("latest-openings"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "texts__component_title--bold",
                    children: [
                        currentCategory.name,
                        " – ",
                        title
                    ]
                })
            }),
            jobs.map(function(card, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobList/* JobCard */.t, (0,_object_spread/* default */.Z)({}, card), index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: getStyleClassName("latest-openings", "see-more"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_460da2fc.L, {
                    href: generateOpenJobsPageLink(currentCategory),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_eec2778c.B.Primary, {
                        text: seeMoreButtonText,
                        asDiv: true
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../wif-ui-lib/dist/Chips-79201180.mjs
var Chips_79201180 = __webpack_require__(8033);
;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/PopularCategories.tsx



function PopularCategories(param) {
    var title = param.title, _categories = param.categories, categories = _categories === void 0 ? [] : _categories;
    if (categories.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(useClickOutside_55c64a80.B.Content, {
        className: getStyleClassName("content"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: getStyleClassName("popular-categories"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "texts__component_title--bold",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: getStyleClassName("popular-categories", "chips"),
                    children: categories.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chips_79201180.C, {
                            text: category.name,
                            href: generateOpenJobsPageLink(category)
                        }, category.id);
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/OpenJobsHighlight.tsx








function OpenJobsHighlight(props) {
    var _heading = props.heading, heading = _heading === void 0 ? "Open jobs" : _heading, _subHeading = props.subHeading, subHeading = _subHeading === void 0 ? "English speaking jobs across Finland" : _subHeading, _categoriesTitle = props.categoriesTitle, categoriesTitle = _categoriesTitle === void 0 ? "Most popular job categories" : _categoriesTitle, _openingsTitle = props.openingsTitle, openingsTitle = _openingsTitle === void 0 ? "Latest openings" : _openingsTitle, _seeMoreButtonText = props.seeMoreButtonText, seeMoreButtonText = _seeMoreButtonText === void 0 ? "See more" : _seeMoreButtonText, _totalJobs = props.totalJobs, totalJobs = _totalJobs === void 0 ? 0 : _totalJobs, _categories = props.categories, categories = _categories === void 0 ? [] : _categories;
    // Revalidating data
    var data = (0,useQuery/* default */.Z)("/api/jobs/status/", {
        cacheDurationInMs: durations/* ONE_MIN_IN_MS */.sW * 10,
        initialData: {
            totalJobs: totalJobs,
            categories: categories
        }
    }).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: openJobsHighlightId,
        "data-testid": openJobsHighlightId,
        className: getStyleClassName(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* SectionHeader */.M, {
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(useClickOutside_55c64a80.B, {
                topPadding: useClickOutside_55c64a80.B.Padding.NONE,
                bottomPadding: useClickOutside_55c64a80.B.Padding.SMALL,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(useClickOutside_55c64a80.B.Content, {
                        className: getStyleClassName("content"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                gridColumn: "1/-1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: getStyleClassName("total-count"),
                                    children: data.totalJobs
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "heading__section",
                                    children: subHeading
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularCategories, {
                        title: categoriesTitle,
                        categories: data.categories
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestOpenings, {
                        title: openingsTitle,
                        categories: data.categories,
                        seeMoreButtonText: seeMoreButtonText
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/OpenJobsHighlight/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 7241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"open-jobs-highlight":"OpenJobsHighlight_open-jobs-highlight__D2j2y","open-jobs-highlight__content":"OpenJobsHighlight_open-jobs-highlight__content__jw0ct","open-jobs-highlight__total-count":"OpenJobsHighlight_open-jobs-highlight__total-count__liBj3","open-jobs-highlight__popular-categories":"OpenJobsHighlight_open-jobs-highlight__popular-categories__Gu2qi","open-jobs-highlight__popular-categories__chips":"OpenJobsHighlight_open-jobs-highlight__popular-categories__chips__kX8W0","open-jobs-highlight__latest-openings":"OpenJobsHighlight_open-jobs-highlight__latest-openings__c8_8W","open-jobs-highlight__latest-openings__see-more":"OpenJobsHighlight_open-jobs-highlight__latest-openings__see-more__jeKat"};

/***/ }),

/***/ 8132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ to; },
/* harmony export */   "t": function() { return /* binding */ V; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2007);
/* harmony import */ var _Link_460da2fc_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1607);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7720);






const N = "job-card", k = "job-card--image-skeleton-loading", y = "skeleton", f = "job-card--text-skeleton-loading", u = "job-card--pressed", x = "job-card__title", h = "job-card__title--loading", S = "skeleton-loading", F = "job-card__employerName", G = "job-card__expiry-label", H = "job-card__go-to-job-container", J = "job-card__go-to-job-container__title", P = "job-card__location", v = "job-card__location-icon", R = "job-card__go-to-job-icon", B = "job-card__logo", O = "job-card__logo--place-holder", w = "job-card__logo__image", A = "job-card__logo__image--hide", W = "job-card--header", $ = "job-card--score", z = "job-card--score--number", U = "job-card--title-company", q = "job-card--footer", K = "job-card--footer--left-item", M = "desktop", Q = "job-card--footer--right-item", o = {
  jobCard: N,
  jobCardImageSkeletonLoading: k,
  skeleton: y,
  jobCardTextSkeletonLoading: f,
  jobCardPressed: u,
  jobCardTitle: x,
  jobCardTitleLoading: h,
  skeletonLoading: S,
  jobCardEmployerName: F,
  jobCardExpiryLabel: G,
  jobCardGoToJobContainer: H,
  jobCardGoToJobContainerTitle: J,
  jobCardLocation: P,
  jobCardLocationIcon: v,
  jobCardGoToJobIcon: R,
  jobCardLogo: B,
  jobCardLogoPlaceHolder: O,
  jobCardLogoImage: w,
  jobCardLogoImageHide: A,
  jobCardHeader: W,
  jobCardScore: $,
  jobCardScoreNumber: z,
  jobCardTitleCompany: U,
  jobCardFooter: q,
  jobCardFooterLeftItem: K,
  desktop: M,
  jobCardFooterRightItem: Q
};
function V({
  title: m,
  employerName: c,
  location: d,
  link: n,
  image: l,
  isDataLoading: a = !0,
  score: r,
  scoreLabel: b = "match"
}) {
  const [p, C] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), _ = n ? _Link_460da2fc_mjs__WEBPACK_IMPORTED_MODULE_1__.L : "div", i = n ? { href: n, disableLinkTextStyle: !0, target: "_blank" } : {};
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _,
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(o.jobCard),
      "data-testid": "job-card",
      href: i.href || "",
      ...i
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(o.jobCardHeader) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(o.jobCardTitleCompany) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "p",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          o.jobCardTitle,
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsBodyTextBold,
          a && o.jobCardTextSkeletonLoading
        )
      },
      m
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "p",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          o.jobCardEmployerName,
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsBodyText,
          a && o.jobCardTextSkeletonLoading
        ),
        style: { "--text-width": a ? 0.7 : 1 }
      },
      c
    )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          o.jobCardLogo,
          a && o.jobCardImageSkeletonLoading,
          !a && (!p || !l) && o.jobCardLogoPlaceHolder
        )
      },
      l && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "img",
        {
          className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            o.jobCardLogo,
            a && o.jobCardLogoImageHide
          ),
          src: l,
          alt: `Logo, ${c}`,
          loading: "lazy",
          onLoad: () => C(!0),
          onError: (E) => {
            E.currentTarget.classList.add(o.jobCardLogoImageHide), C(!1);
          }
        }
      )
    )),
    r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(o.jobCardScore) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "span",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(o.jobCardScoreNumber)
      },
      `${r}%`
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, b))),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(o.jobCardFooter) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          o.jobCardFooterLeftItem,
          a && o.jobCardTextSkeletonLoading
        ),
        style: {
          "--extra-width": a ? "0%" : "10%"
        }
      },
      !a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.W.LOCATION, width: 20, height: 21 }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "p",
        {
          className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            o.jobCardLocation,
            _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsBodyText
          )
        },
        d === "unknown" || !d ? "Finland" : d
      ))
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          o.jobCardFooterRightItem,
          a && o.jobCardTextSkeletonLoading
        )
      },
      !a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(o.jobCardGoToJobContainer) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "span",
        {
          className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            o.jobCardGoToJobContainerTitle,
            _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.buttonTitle
          )
        },
        "Go to job site"
      ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
        {
          className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(o.jobCardGoToJobIcon),
          icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.W.ARROW_UP_RIGHT,
          color: "#002EA2"
        }
      ))
    ))
  );
}
function to({
  jobCards: m,
  skeletonLoadingCount: c = 12,
  topPadding: d = _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_4__.B.Padding.NONE,
  bottomPadding: n = _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_4__.B.Padding.NONE
}) {
  const a = m ?? ((r) => Array(r).fill({ isDataLoading: !0 }))(c);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_4__.B,
    {
      "data-testid": "job-list",
      topPadding: d,
      bottomPadding: n
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_4__.B.Content, null, a.map((r, b) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(V, { key: b, ...r })))
  );
}

//# sourceMappingURL=JobList.js.map


/***/ }),

/***/ 933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ f; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7720);



const m = "section-header", p = "section-header__heading", l = "desktop", h = "section-header__lead-text", L = "section-header--noGap", y = "section-header--lightBlue", u = "section-header--gray", t = {
  sectionHeader: m,
  sectionHeaderHeading: p,
  desktop: l,
  sectionHeaderLeadText: h,
  sectionHeaderNoGap: L,
  sectionHeaderLightBlue: y,
  sectionHeaderGray: u
};
function f({
  id: c,
  leadText: n,
  backgroundColor: i,
  children: e
}) {
  const r = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    i === "lightBlue" ? t.sectionHeaderLightBlue : i === "gray" && t.sectionHeaderGray
  ), H = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => !!e && (typeof e != "string" || !!e.trim()),
    [e]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      id: c,
      topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      bottomPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      className: r
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content, { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(n && t.sectionHeaderNoGap) }, H && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "h2",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.headingSection,
          t.sectionHeaderHeading
        ),
        "data-testid": "section-header"
      },
      e
    ), n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "p",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitle,
          t.sectionHeaderLeadText
        ),
        "data-testid": "section-header-lead-text"
      },
      n
    ))
  );
}

//# sourceMappingURL=SectionHeader.js.map


/***/ }),

/***/ 3842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 8033:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ _; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _Link_460da2fc_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1607);
/* harmony import */ var _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2007);




const b = "chips", k = "chips--compact", E = "chips--bolder", I = "close-icon", o = {
  chips: b,
  chipsCompact: k,
  chipsBolder: E,
  closeIcon: I
}, i = 40;
function _(e) {
  const {
    text: c = "",
    variant: l = "standard",
    bolder: r = !1,
    clipLongText: h = !0,
    selected: s,
    showXWhenSelected: m = !1
  } = e, p = c.length > i, n = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, p && h ? `${c.slice(0, i).trim()}...` : c, m && s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_1__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_1__.W.CLOSE, className: o.closeIcon })), a = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
    e.className,
    r ? o.chipsBolder : _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsBodyText,
    o.chips,
    l === "compact" && o.chipsCompact
  );
  return e.as === "button" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      className: a,
      onClick: e.onClick,
      "aria-checked": !!s,
      role: "checkbox",
      title: c
    },
    n
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_460da2fc_mjs__WEBPACK_IMPORTED_MODULE_3__.L,
    {
      title: c,
      href: e.href || "#",
      disableLinkTextStyle: !0,
      "aria-checked": !!s,
      role: "checkbox",
      className: a
    },
    n
  );
}

//# sourceMappingURL=Chips-79201180.mjs.map


/***/ })

}]);